import React from 'react';

import { ReactComponent as SaveIcon } from 'assets/icons/SaveIcon.svg';

import { Button } from 'components/_basic/Button/Button';

import { ISavePaymentHistoryButtonProps } from './types';

const removeQueryParams = (urlString: string) => {
  const url = new URL(urlString);
  url.search = '';
  return url.href;
};

export const SavePaymentHistoryButton: React.FC<ISavePaymentHistoryButtonProps> = ({ paymentHistory }) => {
  if (!paymentHistory.receipt) {
    return null;
  }

  const receiptLink = removeQueryParams(paymentHistory.receipt);
  const downloadLink = receiptLink + '/pdf';

  return (
    <a href={downloadLink} download={`Receipt-${paymentHistory.operationId}.pdf`}>
      <Button size="small" variant="text" sx={{ padding: 0 }}>
        <SaveIcon />
      </Button>
    </a>
  );
};
